<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->
                <mdb-card-title>
                    <!-- Project Title -->
                    <h2>CREATION D'UN JEU DE GEOGRAPHIE POUR ENFANT REALISE EN HTML CSS JS </h2>
                    <!-- Project date + duration -->
                    <h4><b>Fin :</b> En cours</h4>
                    <h4><b>Durée :</b> > 6 mois</h4>
                </mdb-card-title>
                <!-- Project image -->
                <mdb-card-img class="project-picture" src="assets/geo.png"></mdb-card-img>
                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/html.png" />
                                <img class="dot" src="assets/skills/css.png" />
                                <img class="dot" src="assets/js.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p>Html, Css, Javascript</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Contexte :</b></h4>
                            <p>
                                Etant un passioné de jeux vidéos, j'ai toujours souhaité créer mon propre jeu. C'est pourquoi j'ai décidé de commencer à en coder un lors de mon projet en Terminale au lycée pendant mes cours de ISN. A côté de cela, j'ai décidé de partager l'avancée de
                                mon travail sur mon compte github :
                                <a href="https://github.com/hugo59400/ISN" target="blank">lien vers mon compte </a>; non seulement afin d'avoir un suivi de l'évolution du projet, mais aussi pour partager ce que j'ai fais pour éventuellement avoir des
                                retours.
                            </p>
                            <h4><b>Présentation du projet :</b></h4>
                            <p>
                                La carte désigne par défaut aléatoirement un Etat des Etats-Unis et donc il faut trouver le drapeau correspondant à l'état parmi les 3 drapeaux proposés
                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>
                                Ce jeu m'a permi de m'ameliorer en javascript Voici mon site hebergé en ligne :
                                <li><a href="https://geographygame.netlify.app/" target="blank">Mon site </a></li>
                            </p>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>

        </div>
    </div>
</div>

<app-projects></app-projects>